import { TachoReleaseInformationModel } from '../../../../domainModels/versions/TachoInstallerModel';
import { createDateFromTimeZone } from '../../../../helpers/moment';
import { TachoReleaseInformation } from 'tacho-models';
import { mapApiModelToTachoReleaseType } from '../../../../domainModels/versions/TachoReleaseType';

export const mapApiTachoInstallerModel = (model: TachoReleaseInformation): TachoReleaseInformationModel => ({
    ...model,
    releaseDate: createDateFromTimeZone(model.releaseDate, undefined, 'utc'),
    releaseType: mapApiModelToTachoReleaseType(model.releaseType),
    component: (model as TachoReleaseInformation & { component?: string }).component ?? '',
});
